<div class="container-fluid glb-popup">
  <p-toast [style]="{marginTop: '80px'}"></p-toast>
  @if (isSearching) {
    <div class="kbm-search-loading">
      <p-progressSpinner></p-progressSpinner>
    </div>
  }
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <h2> {{title}}</h2>
  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>

    <div class="forms w-300 d-block">
      <div class="row m-0">
        <div class="col-lg-12">
          @if (!displayClose) {
            <br>
            }
            <p-table class="kbmadmintable reservation-ledgers-summary" #pt [value]="reservationLedgers" [paginator]="true" [rows]="100" [rowsPerPageOptions]="[100,150,200]"
              [totalRecords]="recordTotal" [lazy]="true" (onLazyLoad)="loadLazy($event)" sortMode="multiple" [multiSortMeta]="multiSortMeta"
              selectionMode="single" dataKey="reservationLedgerId"
              [(selection)]="reservationLedger" (onRowSelect)="onRowSelect($event)" [loading]="loading"
              showCurrentPageReport="true" currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}"
              styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}" [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

              <ng-template pTemplate="caption">
                <div class="d-block text-end orderdetails-btn">
                  <span>
                    <!--clear filters-->
                    <button pButton pRipple class="p-button-text"
                      style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
                    (click)="reloadPage()">Clear Filters</button>

                    <!--add new-->
                    <!-- <button pButton pRipple class="p-button-outlined" style="padding: 0.643rem 0.75rem !important;  margin-right:10px;"
                  (click)="generateLedgers()">Re-Generate</button>
                  <button pButton pRipple class="p-button-outlined" style="padding: 0.643rem 0.75rem !important;  margin-right:10px;"
                  (click)="lockLedger()">Lock Ledger</button>
                  <button pButton pRipple class="p-button-outlined" style="padding: 0.643rem 0.75rem !important;  margin-right:10px;"
                  (click)="unlockLedger()">Unlock Ledger</button>
                  <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
                  (click)="onOpenFormAdd()">New ReservationLedger +</button> -->
                </span>
              </div>
            </ng-template>
            <ng-template pTemplate="header">
              <tr>
                @for (col of columns; track col) {
                  <th [pSortableColumn]="col.sortingField" [ngStyle]="{'width': 'auto'}">
                    {{col.header}}
                    <p-sortIcon [field]="col.sortingField"></p-sortIcon>
                  </th>
                }
                <th [ngStyle]="{'width': 'auto'}">Total</th>
                <th [ngStyle]="{'width': 'auto'}">Grand Total</th>
                <th [ngStyle]="{'width': 'auto'}">Net Total</th>
                <th [ngStyle]="{'width': 'auto'}"></th>
              </tr>
              <tr>
                <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'reservationVO.shortTermRentalVO.propertyCode', 'in')"></th>
                <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'reservationVO.guestProfileVO.lastName', 'in')"></th>
                <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'reservationVO.orderVO.orderId', 'in')"></th>
                <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'reservationVO.reservationId', 'in')"></th>
                <!-- <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'status', 'in')"></th> -->
                <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:100px;" type="date"
                (input)="pt.filter($event.target.value, 'reservationVO.checkInDateTime', 'in')"></th>
                <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:100px;" type="date"
                (input)="pt.filter($event.target.value, 'reservationVO.checkOutDateTime', 'in')"></th>
                <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'orderProductVO.name', 'in')"></th>
                <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'payFromOrderProductVO.name', 'in')"></th>
                <th [ngStyle]="{'width': 'auto'}">
                  <!-- <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'payFrom', 'in')"> -->
                  <p-multiSelect [options]="reservationLedgerService.payToDetails" defaultLabel="name"
                  optionLabel="name" (onChange)="pt.filter($event.value, 'payFrom', 'in')" appendTo="body"></p-multiSelect>
                </th>
                <th [ngStyle]="{'width': 'auto'}">
                  <p-multiSelect [options]="reservationLedgerService.payToDetails" defaultLabel="name"
                  optionLabel="name" (onChange)="pt.filter($event.value, 'payTo', 'in')" appendTo="body"></p-multiSelect>
                </th>
                <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'quantity', 'in')"></th>
                <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'listPrice', 'in')"></th>
                <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'listPriceAdjustmentPercent', 'in')"></th>
                <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'listPriceAdjustmentAmount', 'in')"></th>
                <th [ngStyle]="{'width': 'auto'}"></th>
                <th [ngStyle]="{'width': 'auto'}"></th>
                <th [ngStyle]="{'width': 'auto'}"></th>

              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-reservationLedger let-index="rowIndex">
              <tr [ngStyle]="{'background-color': (reservationLedger?.ledgerItemType == 2) ? 'lightgrey' : ''}" [pSelectableRow]="reservationLedger">
                <td>{{reservationLedger.propertyCode}}</td>
                <td><a href="https://admin.kbmhawaii.com/order/{{reservationLedger.orderId}}" target="_blank">{{reservationLedger.guestLastName}}</a></td>
                <!-- <td *ngIf="reservationLedger.status==1" style="color: lightgreen;">{{getStatusName(reservationLedger)}}</td>
                <td *ngIf="reservationLedger.status==2" style="color: orange;">{{getStatusName(reservationLedger)}}</td>
                <td *ngIf="reservationLedger.status==3" style="color: red;">{{getStatusName(reservationLedger)}}</td>
                <td *ngIf="reservationLedger.status!=1 && reservationLedger.status!=2 && reservationLedger.status!=3"></td> -->
                <td>{{reservationLedger.orderId}}</td>
                <td>{{reservationLedger.reservationId}}</td>
                <td>{{reservationLedger.checkInDateTime | date}}</td>
                <td>{{reservationLedger.checkOutDateTime | date}}</td>
                <td>{{getReservationLedgerTitle(reservationLedger)}}</td>
                <td>{{reservationLedger.payFromOrderProductName}}</td>
                <td>{{getPayFromName(reservationLedger)}}</td>
                <td>{{getPayToName(reservationLedger)}}</td>
                <td>{{reservationLedger.quantity}}</td>
                <td>{{reservationLedger.listPrice | currency : 'USD' : 'symbol' : '1.2-2'}}</td>
                <td>{{reservationLedger.listPriceAdjustmentPercent | percent}}</td>
                <td>{{reservationLedger.listPriceAdjustmentAmount | currency : 'USD' : 'symbol' : '1.2-2'}}</td>
                <td>{{total(reservationLedger) | currency : 'USD' : 'symbol' : '1.2-2'}}</td>
                <td>{{grandTotalFromLedgerMap(reservationLedger.reservationId) | currency : 'USD' : 'symbol' : '1.2-2'}}</td>
                <td>{{netTotalFromLedgerMap(reservationLedger.reservationId) | currency : 'USD' : 'symbol' : '1.2-2'}}</td>
                <td><span style="float:none">
                  <a>
                    <i class="pi pi-pencil" aria-hidden="true"
                    style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenFormEdit(reservationLedger)"></i>
                  </a>
                  <a>
                    @if (reservationLedger?.regenerateOption == 1) {
                      <i class="pi pi-lock" aria-hidden="true"
                      style="color:blue; font-size:110%; padding-right:20px;" (click)="toggleLedgerItemsLock(reservationLedger)"></i>
                    }
                  </a>
                  <a>
                    @if (reservationLedger.regenerateOption == undefined || reservationLedger.regenerateOption == null || reservationLedger.regenerateOption == 0) {
                      <i class="pi pi-lock-open" aria-hidden="true"
                      style="color:blue; font-size:110%; padding-right:20px;" (click)="toggleLedgerItemsLock(reservationLedger)"></i>
                    }
                  </a>
                </span>
              </td>
            </tr>
            <!-- <tr *ngIf="(reservationLedgers.length - 1) == index">
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>Grand Total</td>
            <td>{{grandTotal() | currency : 'USD' : 'symbol' : '1.2-2'}}</td>
            <td></td>
          </tr> -->

        </ng-template>


      </p-table>

    </div>
  </div>
</div>
</div>
